Pixlee.module('Concerns', function(Concerns, App, Backbone, Marionette, $) {

    Concerns.HorizontalCollectionView = {
        onShow: function() {
            var _this = this;
            if (gon.isMobileDevice) {
                this.width = 0;
                $(this.el).parent().css({
                    'overflow-x': 'scroll',
                    'overflow-y': 'hidden',
                    '-webkit-overflow-scrolling': 'touch'
                });
                //$(this.el).css('height', '100%');
                $('#hw_container').width(gon.containerWidth); // for ios...parents were using computed width of this.el...
            } else {
                this.startSly();
                $('#left-nav-arrow').addClass('inactive-arrow');
            }
            if (this.collection.length === 0) {
                $('#widget_header_table,#photowall_description').css('opacity', '1');
            }
        },
        startSly: function() {
            this.sly = new Sly($(this.el).parent(), {
                horizontal: 1,
                itemNav: 'basic',
                itemSelector: '.photo-item-container',
                speed: 300
            });
            this.sly.init();
            if (gon.v2) {
                $('body').css({
                    'padding-right': '40px',
                    'padding-left': '40px'
                });
                this.setWidgetHeight();
            }
        },
        onAddChild: function(childView) {
            var _this = this;
            clearTimeout(this.timer);
            if (!this.firstLoad) {
                this.timer = setTimeout(function() {
                    _this.firstLoad = true;
                }, 100);

                this.$el.imagesLoaded().always(function() {
                    _this.loadSly(childView);
                });
            } else {
                this.$el.unbind('.imagesLoaded');
                _this.loadSly(childView);
            }

        },
        loadSly: function(childView) {
            var _this = this;


            if (gon.v2) {
                var photoblock = $(childView.$el).find('.photo_block');
                childView.$el.css({
                    opacity: 1
                });
                var imageHolder = $(childView.$el).find('.lightboxed, .img_holder');

                var bottom = $(childView.$el).find('svg, .image_info');
                photoblock.css({
                    height: _this.getPhotoSize(),
                    width: _this.getPhotoSize()
                });
                imageHolder.css({
                    height: _this.getPhotoSize(),
                    width: _this.getPhotoSize()
                });
                bottom.css({
                    width: _this.getPhotoSize()
                });
            } else {
                childView.$el.css({
                    opacity: 1,
                    height: 210 + 'px',
                    width: 220 + 'px',
                    float: 'left',
                    display: 'block'
                });
                $(childView.$el).find('.layer_share').css({
                    height: 210 + 'px',
                    width: 200 + 'px',
                    top: 0
                });

                $(childView.$el).find('.vote_button').css({
                    'margin-left': '22px',
                    'left': 'auto'
                });
            }
            if (!gon.isMobileDevice && !this.initialized) {
                this.initialized = true;
                setTimeout(function() {
                    _this.sly.reload();
                }, 50);

            } else if (!gon.isMobileDevice && this.initialized) {
                _this.sly.reload();
            }
            _this.trigger('images:loaded');
            if (gon.isMobileDevice) {
                this.width += $('.photo-item-container').outerWidth() + 15;
                $(this.el).width(this.width);
            }
        },
        setWidgetHeight: function() {
            $('#widgets_main_region').removeClass('photowall_widget_medium');
            if (gon.display_options && gon.display_options.photoSize === 'small_photo') {
                $('#widgets_main_region').addClass('photowall_widget_small');
            } else if (gon.display_options && gon.display_options.photoSize === 'medium_photo') {
                $('#widgets_main_region').addClass('photowall_widget_medium');
            } else if (gon.display_options) {
                $('#widgets_main_region').addClass('photowall_widget_large');
            }
        },
        getPhotoSize: function() {
            if (gon.v2) {
                if (gon.display_options && gon.display_options.photoSize === 'small_photo') {
                    return '150px';
                } else if (gon.display_options && gon.display_options.photoSize === 'medium_photo') {
                    return '200px';
                } else if (gon.display_options) {
                    return '260px';
                }
            } else {
                if (gon.display_options && gon.display_options.photoSize === 'small_photo') {
                    return '150px';
                } else if (gon.display_options && gon.display_options.photoSize === 'medium_photo') {
                    return '200px';
                } else if (gon.display_options) {
                    return '240px';
                }
            }

        },
        onBeforeAddChild: function(childView) {
            if (!this.initLoader && !gon.isMobileDevice) {
                this.showLoader();
            }
            childView.$el.css({
                opacity: 0
            });
        },
        onDestroy: function() {},
        calcHorizontal: function() {
            // var top =(($('#widget_header_table').height() + $('#photos_container').height())/ 2 ) + 20;
            $('.arrows').css({
                'margin-top': '-' + (parseInt(this.getPhotoSize(), 10) + 10) + 'px',
                'height': parseInt(this.getPhotoSize(), 10) + 'px'
            });
            // $('.arrows').css('top', top + 'px');
        }
    };

});
